export default "__VITE_ASSET__brZh8eiJ__"